/**
*  Date    : 2021/05/14
*  Author  : lbb1811
*  Declare : reader
*/
import Immutable from 'seamless-immutable';

import readercenter from '@/api/readercenter';
import matrixcenter from '@/api/matrixcenter';
import authUtils from '@/business/authorize/authUtils';

import page from './utils/page';

export default {
  namespace: 'reader',
  state: Immutable({
    hasPhoneNumber: false, // 用户授权了手机号
    showLoginModal: false, // 展示login弹窗
    canCancelLogin: true, // 能关闭login弹窗
    loginModalClassname: '', //login弹窗新增类名
    routeSpm: '0', // LOGIN spm
    gradeLabel: '', // 用户标签
    raysLabel: {}, // 用户身份标签
    jumpWay: sessionStorage.getItem('jumpWay'), //跳转方式 是否打开小程序 WeApp H5
    isCanReceiveCount: 0 // 荣誉勋章-用户可以领取奖励的勋章数目
  }),
  reducers: {
    update: (state, { data, field }) => {
      return state.merge({ [field]: data });
    },
    updatePageBean: (state, { data, field }) => {
      const pageBean = Immutable.merge(page(state[field]).append(data));
      return state.merge({ [field]: pageBean });
    },
    /** 设置login弹窗状态 */
    updateLoginState: (state, { data = {}, field }) => {
      // hasPhoneNumber showLoginModal canCancelLogin
      let values = Object.assign(data, { hasPhoneNumber: !authUtils.getCookieUser().isTempUser || data.hasPhoneNumber });
      console.log(values);
      return state.merge(values);
    }
  },
  actions: {
    /** 查询用户标签 */
    getUserGradeLabel: data => ({
      type: 'reader/update',
      promise: readercenter.getUserGradeLabel(data),
      field: 'gradeLabel'
    }),
    /** 设置login弹窗状态 */
    updateLoginState: data => ({
      type: 'reader/updateLoginState',
      promise: Promise.resolve(data)
    }),
    /** 获取当前用户关联的手机号码 */
    getUserPhoneNumber: data => ({
      type: 'reader/update',
      promise: readercenter.getUserPhoneNumber(data),
      field: 'hasPhoneNumber'
    }),
    /** 获取用户身份标签 */
    getUserBaseRaysLabel: data => ({
      type: 'reader/update',
      promise: readercenter.getUserBaseRaysLabel(data),
      field: 'raysLabel'
    }),
    /** 设置跳转类型 */
    updateJumpWayState: data => ({
      type: 'reader/update',
      promise: Promise.resolve(data),
      field: 'jumpWay'
    }),
    // 获取用户可以领取奖励的勋章数目
    getIsCanReceiveCount: data => ({
      type: 'reader/update',
      promise: matrixcenter.getUserIsCanReceiveCount(),
      field: 'isCanReceiveCount'
    })
  }
};
